import * as actionTypes from './actionTypes';

export const setInstruksieCardsLoading = () => {
    return {
        type: actionTypes.SET_LOADING_INSTRUKSIES_CARDS
    };
};

export const initKryInstruksiesCards = () => {
    return {
        type: actionTypes.INIT_INSTRUKSIES_CARDS
    };
};

export const getInstruksiesCards = () => {
    return {
        type: actionTypes.GET_INSTRUKSIES_CARDS
    };
};

export const setInstruksiesCards = (cards) => {
    return {
        type: actionTypes.SET_INSTRUKSIES_CARDS,
        cards: cards
    };
};

export const getInstruksiesCardsFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_INSTRUKSIES_CARDS_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const openSienInstruksieModal = () => {
    return {
        type: actionTypes.OPEN_SIEN_INSTRUKSIE
    };
};

export const closeSienInstruksieModal = () => {
    return {
        type: actionTypes.CLOSE_SIEN_INSTRUKSIE
    };
};

export const selectInstruksie = (instruksie) => {
    return {
        type: actionTypes.SELECT_INSTRUKSIE,
        instruksie: instruksie
    };
};

export const kiesInstruksie = (instruksie) => {
    return {
        type: actionTypes.KIES_INSTRUKSIE,
        instruksie: instruksie
    };
};

export const setInstruksieView = (view) => {
    return {
        type: actionTypes.INSTR_SET_VIEW,
        view: view
    };
};

export const addDatum = () => {
    return {
        type: actionTypes.INSTR_ADD_DATUM
    };
};

export const subtractDatum = () => {
    return {
        type: actionTypes.INSTR_SUBTRACT_DATUM
    };
};

export const setVandagDatum = () => {
    return {
        type: actionTypes.INSTR_SET_VANDAG
    };
};

export const setDatum = (datum) => {
    return {
        type: actionTypes.INSTR_SET_DATUM,
        datum: datum
    };
};

export const setInstruksieDatumsGekry = (datums) => {
    return {
        type: actionTypes.INSTR_SET_DATUMS_GEKRY,
        datums: datums
    };
};

export const setInstruksiesFilter = (tipe, ids) => {
    return {
        type: actionTypes.SET_INSTRUKSIES_FILTER,
        tipe: tipe,
        ids: ids
    };
};

export const clearInstruksiesFilter = () => {
    return {
        type: actionTypes.CLEAR_INSTRUKSIES_FILTER,
    };
};

export const clearInstruksieCards = () => {
    return {
        type: actionTypes.CLEAR_INSTRUKSIES_CARDS,
    };
};

export const searchInstruksies = (data) => {
    return {
        type: actionTypes.SEARCH_INSTRUKSIES,
        data: data
    };
};

export const instrInvulStelDatums = (datums) => {
    return {
        type: actionTypes.INSTR_INVUL_STEL_DATUMS,
        datums: datums
    };
};


export const instrInvulStelDatumsTye = (datum, tye) => {
    return {
        type: actionTypes.INSTR_INVUL_STEL_DATUMS_TYE,
        datum: datum,
        tye: tye
    };
};

export const instrInvulRemoveRekord = (afdeling, id) => {
    return {
        type: actionTypes.INSTR_INVUL_REMOVE_REKORD,
        afdeling: afdeling,
        id: id
    };
};

export const instrInvulRemoveNestedRekord = (afdeling, nestedafdeling, id) => {
    return {
        type: actionTypes.INSTR_INVUL_REMOVE_NESTED_REKORD,
        afdeling: afdeling,
        nestedafdeling: nestedafdeling,
        id: id
    };
};

export const instrInvulStelRekordTyd = (afdeling, id, datum, value, klokid) => {
    return {
        type: actionTypes.INSTR_INVUL_STEL_REKORD_TYD,
        afdeling: afdeling,
        id: id,
        datum: datum,
        value: value,
        klokid: klokid
    };
};

export const instrInvulStelNestedRekordTyd = (afdeling, nestedafdeling, id, datum, value, klokid) => {
    return {
        type: actionTypes.INSTR_INVUL_STEL_NESTED_REKORD_TYD,
        afdeling: afdeling,
        nestedafdeling: nestedafdeling,
        id: id,
        datum: datum,
        value: value,
        klokid: klokid
    };
};

export const openInstrInvulDataModal = () => {
    return {
        type: actionTypes.INSTR_INVUL_DATA_OPEN
    };
};

export const closeInstrInvulDataModal = () => {
    return {
        type: actionTypes.INSTR_INVUL_DATA_CLOSE
    };
};

export const instrInvulDataModalContent = (content) => {
    return {
        type: actionTypes.INSTR_INVUL_DATA_MODAL_CONTENT,
        content: content
    };
};

export const instrInvulAddArbeiders = (afdeling, arbeiders) => {
    return {
        type: actionTypes.INSTR_INVUL_ADD_ARBEIDERS,
        afdeling: afdeling,
        arbeiders: arbeiders
    };
};

export const instrInvulAddItemtipes = (afdeling, ids) => {
    return {
        type: actionTypes.INSTR_INVUL_ADD_ITEMTIPES,
        afdeling: afdeling,
        ids: ids
    };
};

export const instrInvulAddItems = (afdeling, nestedafdeling, ids) => {
    return {
        type: actionTypes.INSTR_INVUL_ADD_ITEMS,
        afdeling: afdeling,
        nestedafdeling: nestedafdeling,
        ids: ids
    };
};

export const instrInvulAddVerbruiksItems = (afdeling, ids) => {
    return {
        type: actionTypes.INSTR_INVUL_ADD_VERBRUIKSITEMS,
        afdeling: afdeling,
        ids: ids
    };
};

export const instrInvulSetItemIdSelected = (id) => {
    return {
        type: actionTypes.INSTR_INVUL_SET_ITEM_ID_SELECTED,
        id: id
    };
};

export const instrInvulSetInstruksieLoading = () => {
    return {
        type: actionTypes.INSTR_INVUL_SET_LOADING_INSTRUKSIE
    };
};

export const instrInvulInitKryInstruksie = (id) => {
    return {
        type: actionTypes.INSTR_INVUL_INIT_INSTRUKSIE,
        id: id
    };
};

export const instrInvulGetInstruksie = () => {
    return {
        type: actionTypes.INSTR_INVUL_GET_INSTRUKSIE
    };
};

export const instrInvulSetInstruksie = (value) => {
    return {
        type: actionTypes.INSTR_INVUL_SET_INSTRUKSIE,
        value: value
    };
};

export const instrInvulGetInstruksieFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.INSTR_INVUL_GET_INSTRUKSIE_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const instrInvulSetInstruksieIngevulLoading = () => {
    return {
        type: actionTypes.INSTR_INVUL_SET_LOADING_INSTRUKSIE
    };
};

export const instrInvulInitKryInstruksieIngevul = (id) => {
    return {
        type: actionTypes.INSTR_INVUL_INIT_INSTRUKSIE_INGEVUL,
        id: id
    };
};

export const instrInvulGetInstruksieIngevul = () => {
    return {
        type: actionTypes.INSTR_INVUL_GET_INSTRUKSIE_INGEVUL
    };
};

export const instrInvulSetInstruksieIngevul = (value) => {
    return {
        type: actionTypes.INSTR_INVUL_SET_INSTRUKSIE_INGEVUL,
        value: value
    };
};

export const instrInvulGetInstruksieIngevulFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.INSTR_INVUL_GET_INSTRUKSIE_INGEVUL_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const instrInvulChangeCustomFieldValue = (afdeling, id, value, datum, klokid) => {
    return {
        type: actionTypes.INSTR_INVUL_CHANGE_CUSTOMFIELD_VALUE,
        afdeling: afdeling,
        id: id,
        value: value,
        datum: datum,
        klokid: klokid
    };
};